import { GeaoPaths } from "./GeaoPaths";

/**
 * Factory function to generate Producer flow vertical stepper elements.
 * Conditionally displays "Submit Application" for offshore residents when the feature flag is enabled.
 * 
 * @param {boolean} [enableOffshore=false] - Whether the offshore feature flag is enabled
 * @param {boolean} [isOffshoreResident=false] - Whether the current agent is an offshore resident
 * @returns {Array} Array of vertical stepper section objects
 * 
 * When enableOffshore is true and isOffshoreResident is true:
 * - Shows "Submit Application" instead of "Review and Sign"
 * - Redirects to ProducerSubmitApplication page after Background Information
 * 
 * When enableOffshore is false or isOffshoreResident is false:
 * - Shows "Review and Sign" as normal
 * - Redirects to ProducerReviewAndSign page after Background Information
 */
export function getProducerFlowVerticalStepperElements(enableOffshore = false, isOffshoreResident = false) {
    const showSubmitApplication = enableOffshore && isOffshoreResident;

    return Object.freeze([
        {
            title: "Personal",
            items: [
                {
                    text: "Personal Information",
                    path: GeaoPaths.ProducerPersonalInformation
                },
                {
                    text: "Background Information",
                    path: GeaoPaths.ProducerBackgroundInformation
                }
            ]
        },
        {
            title: "Finalize",
            items: [
                {
                    text: showSubmitApplication ? "Submit Application" : "Review and Sign",
                    path: showSubmitApplication ? GeaoPaths.ProducerSubmitApplication : GeaoPaths.ProducerReviewAndSign
                },
                {
                    text: "Application Submitted",
                    path: GeaoPaths.ProducerApplicationSubmitted
                }
            ]
        }
    ]);
}

/**
 * Default static elements for backward compatibility and initial rendering.
 * This is the default stepper when no offshore feature flag is enabled.
 */
const ProducerFlowVerticalStepperElements = Object.freeze([
    {
        title: "Personal",
        items: [
            {
                text: "Personal Information",
                path: GeaoPaths.ProducerPersonalInformation
            },
            {
                text: "Background Information",
                path: GeaoPaths.ProducerBackgroundInformation
            }
        ]
    },
    {
        title: "Finalize",
        items: [
            {
                text: "Review and Sign",
                path: GeaoPaths.ProducerReviewAndSign
            },
            {
                text: "Application Submitted",
                path: GeaoPaths.ProducerApplicationSubmitted
            }
        ]
    }
]);

export default ProducerFlowVerticalStepperElements;
